import { useEffect } from 'react';
import Konami from 'react-konami-code';

import { obtainBadge } from '../../common/badge';
import LetItSnow from '../../common/snow';
import Fun from '../../components/Atoms/Fun';

// Snow
let Snow = null;

const LayoutAsync = ({ currentUser }) => {
  useEffect(() => {
    const evt = setInterval(async () => {
      // Sleepless night badge
      if ((new Date()).getHours() === 4) {
        obtainBadge('ec033641-9d14-4e95-b623-4698b31f19a9');
      }
    }, 15000);
    return () => clearInterval(evt);
  }, []);

  useEffect(() => {
    if (new Date().getMonth() === 11 || (new Date().getDate() <= 6 && new Date().getMonth() === 0)) {
      if (document.querySelector('header')) {
        if (!Snow) {
          Snow = new LetItSnow(document.querySelector('header'));
        }
        Snow.start();
      }
    }
  }, [])

  return <>
    <Konami action={() => obtainBadge('bbf75c71-8c09-4988-ab78-34068c97c474')} />
    {currentUser?.me && <Fun />}
  </>
}

export default LayoutAsync;
